export default "__VITE_PUBLIC_ASSET__2d44fc23__"